import { InfoCircleFilled } from "@ant-design/icons";
import { Button, Input, Modal, Row, Typography, Space, Col, InputNumber, Tooltip } from "antd";
import { addDoc, collection, serverTimestamp } from "firebase/firestore";
import React, { useState } from "react";
import { db } from "../../firebase/config";
import { useAuthContext } from "../../hooks/useAuthContext";
import { Notification } from "../Notification";

const { Text } = Typography;

export default function CreateClientGroupPopup() {
   //user from auth context
   const { user } = useAuthContext();
   const [isModalOpen, setIsModalOpen] = useState(false);
   const [clientGroup, setClientGroup] = useState("");

   //group profitability
   const [groupProfit, setGroupProfit] = useState(0);

   //verify
   const [verifyGroupName, setVerifyGroupName] = useState(false);
   const [mpVerified, setMpVerified] = useState(false);

   const createGroup = async (e) => {
      e.preventDefault();

      //verify if group name is filled
      if (clientGroup.trim().length === 0) {
         setVerifyGroupName(true);
      }

      // //mp specific
      if (user.uid === "C6eD2XCyx5Vi7ANQwqlwdb0Q9Hf2") {
         if (groupProfit <= 0) {
            setMpVerified(true);
         }
      }

      //executes update
      if (clientGroup.trim().length > 0) {
         if (user.uid === "C6eD2XCyx5Vi7ANQwqlwdb0Q9Hf2") {
            if (groupProfit > 0) {
               addData();
            }
         } else {
            addData();
         }
      }
   };

   const addData = async () => {
      const ref = collection(db, "clientGroups");
      try {
         await addDoc(ref, {
            groupName: clientGroup,
            user: user.uid,
            userEmail: user.email,
            approved: false,
            profitability: groupProfit,
            date: {
               timestamp: serverTimestamp(),
               createdAt: serverTimestamp(),
               lastEdit: serverTimestamp(),
            },
         }).then(() => {
            Notification("success", "Group Added", "You have successfully added a client group! Admin Will review it now.");
            setIsModalOpen(false);
            onClose();
         });
      } catch (err) {
         Notification("error", "Creation Error", err.message);
      }
   };

   const onClose = () => {
      setClientGroup("");
      setGroupProfit(0);
      setVerifyGroupName(false);
      setMpVerified(false);
   };

   const showModal = () => {
      setIsModalOpen(true);
   };

   const handleOk = (e) => {
      createGroup(e);
   };

   const handleCancel = () => {
      setIsModalOpen(false);
      onClose();
   };

   const handleGroupName = (e) => {
      setClientGroup(e.target.value);
      if (e.target.value.trim().length > 0) {
         setVerifyGroupName(false);
      }
   };

   //text for mpdruka tooltip
   const text = (
      <>
         <span>
            This is a group percent. Setting this percent will automatically add extra price when you calculate. Group percent affects every client inside it's
            group.
         </span>
      </>
   );

   return (
      <>
         <Button type="primary" onClick={showModal}>
            Create Group
         </Button>
         <Modal title="Create Group" open={isModalOpen} onOk={handleOk} okText="Create" onCancel={handleCancel} width={600}>
            <Row gutter={[10, 10]}>
               <Col span={24}>
                  <Space direction="horizontal">
                     <Space>
                        <Text>Group Name : </Text>
                        <Text italic style={{ color: "red", fontSize: "10px" }}>
                           (required)
                        </Text>
                     </Space>

                     <Input
                        style={{ width: "100%" }}
                        status={verifyGroupName ? "error" : ""}
                        value={clientGroup}
                        onChange={(e) => handleGroupName(e)}
                        placeholder="Client's group name"
                     />
                  </Space>
               </Col>
               {user && user.uid === "C6eD2XCyx5Vi7ANQwqlwdb0Q9Hf2" ? (
                  <Col span={24}>
                     <Space direction="horizontal">
                        <Tooltip placement="bottom" title={text}>
                           <InfoCircleFilled />
                        </Tooltip>
                        <Space>
                           <Text>Group Profitability Percent : </Text>
                           <Text italic style={{ color: "red", fontSize: "10px" }}>
                              (required)
                           </Text>
                        </Space>

                        <InputNumber
                           min={0}
                           max={100}
                           status={mpVerified ? "error" : ""}
                           formatter={(value) => `${value}%`}
                           style={{ width: "100%" }}
                           value={groupProfit}
                           onChange={setGroupProfit}
                           placeholder="Client's group profit "
                        />
                     </Space>
                  </Col>
               ) : (
                  ""
               )}
            </Row>
            <Row justify="center" gutter={[16, 10]}>
               <Col>
                  {verifyGroupName ? (
                     <Text italic style={{ color: "red" }}>
                        Please fill out the required fields!
                     </Text>
                  ) : (
                     ""
                  )}
               </Col>
            </Row>
         </Modal>
      </>
   );
}
